export default import.meta.ROLLDOWN_FILE_URL_hot4uWjEQg5_8jo1Z7BIZQ